import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, List, ListItem, ListItemText } from '@mui/material';
import { ProyectoPorUsuario } from '../../interfaces/BusquedaPersonalDTO';
import { DetallesProyecto } from '../../interfaces/DetallesProyecto';
import { ProyectoBusqueda } from '../../interfaces/ProyectoBusqueda';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: ProyectoBusqueda; // Objeto específico que se llenará en el modal
  detalle: DetallesProyecto;
}

export const DetalleProyectoGeneralModal: React.FC<ModalProps> = ({ isOpen, onClose, data, detalle }) => {

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="modal-title">
      <DialogTitle id="modal-title">Detalles del Proyecto <strong>{detalle.codigoproyecto}</strong></DialogTitle>
      <DialogContent>
        <DialogContentText>
          <List>
            <ListItem key="titulo">
              <ListItemText
                primary={<strong>Titulo:</strong>}
                secondary={detalle.titulo}
              />
            </ListItem>
            <ListItem key="tipoproyecto">
              <ListItemText
                primary={<strong>Tipo de Proyecto:</strong>}
                secondary={detalle.tipoproyecto}
              />
            </ListItem>
            <ListItem key="programainvestigacion">
              <ListItemText
                primary={<strong>Programa de Investigación:</strong>}
                secondary={detalle.programainvestigacion}
              />
            </ListItem>
            <ListItem key="programavinculacion">
              <ListItemText
                primary={<strong>Programa de Vinculación:</strong>}
                secondary={detalle.programavinculacion}
              />
            </ListItem>
            <ListItem key="financiamientoexterno">
              <ListItemText
                primary={<strong>Programa de Vinculación:</strong>}
                secondary={detalle.tipoFinanciamientoExterno}
              />
            </ListItem>
            <ListItem key="fechainicio">
              <ListItemText
                primary={<strong>Fecha Inicio:</strong>}
                secondary={detalle.fechainicio.toString().length > 0 ? detalle.fechainicio.toString().split("T")[0] : ""}
              />
            </ListItem>
            <ListItem key="fechafin">
              <ListItemText
                primary={<strong>Fecha Fin:</strong>}
                secondary={detalle.fechafin.toString().length > 0 ? detalle.fechafin.toString().split("T")[0] : ""}
              />
            </ListItem>
            <ListItem key="tiempoejecucion">
              <ListItemText
                primary={<strong>Tiempo de Ejecución:</strong>}
                secondary={detalle.tiempoejecucion}
              />
            </ListItem>
            <ListItem key="objgeneral">
              <ListItemText
                primary={<strong>Objetivo General:</strong>}
                secondary={detalle.objetivogeneral}
              />
            </ListItem>
            {/* <ListItem key="rol">
              <ListItemText
                primary={<strong>{data.nombrecolaborador} tiene el rol de {data.nombrerol} en este proyecto.</strong>}
              />
            </ListItem> */}
        </List>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} color="secondary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
